import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";

export const statusesApi = async () => {
  const { data } = await api.post(
    API_ROUTES.STATUS_LIST,
    qs.stringify({ ...defaultOptions() })
  );

  return data;
};
